module.exports = __webpack_public_path__ + "img/agency-service-02.b7a7ac03.jpg";